import { asyncLocalStorage } from "library/async-storage.mjs"
const current = {}
const cls = new Proxy(current, {
    get(obj, prop) {
        if (prop === "$$") {
            return asyncLocalStorage.getStore()
        }
        return (asyncLocalStorage.getStore() ?? current)[prop]
    },
    set(obj, prop, value) {
        if (!asyncLocalStorage.getStore()) {
            // Do not comment out the log below.  If you are receiving
            // this log then a call is being made from an external source
            // that is not going through async wrapping for cls.  You
            // should probably be wrapping something in asyncWrapper

            console.log("***************************")
            console.trace("Setting global cls value", prop, value)
            console.log("***************************")
        }
        ;(asyncLocalStorage.getStore() ?? current)[prop] = value
        return true
    },
    has(obj, prop) {
        return prop in (asyncLocalStorage.getStore() ?? {})
    },
})
export { cls }
